import { render, staticRenderFns } from "./TaskListSortBy.vue?vue&type=template&id=7a54bba7&scoped=true"
import script from "./TaskListSortBy.vue?vue&type=script&lang=js"
export * from "./TaskListSortBy.vue?vue&type=script&lang=js"
import style0 from "./TaskListSortBy.vue?vue&type=style&index=0&id=7a54bba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54bba7",
  null
  
)

export default component.exports